import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React from 'react';
import './DatePicker.scss';
import dayjs from 'dayjs';

interface DatePickerProps {
  onChangeHandler: (date: any) => void; // Replace 'any' with the appropriate type if known
  valueField: any; // Replace 'any' with the appropriate type if known
}

const DatePicker: React.FC<DatePickerProps> = ({
  onChangeHandler,
  valueField,
}) => {
  const minDate = dayjs().subtract(20, 'year');
  return (
    <div className='date-picker-wrapper'>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          minDate={minDate}
          format="MM/DD/YYYY"
          sx={{
            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
              border: '1px solid #c9c8c8'
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
              { border: '1px solid #c9c8c8' }
          }}
          views={['year', 'month', 'day']}
          onChange={onChangeHandler}
          slots={{
            openPickerIcon: () => (
              <span className="icon-32-calendar-mono"></span>
            )
          }}
          slotProps={{
            textField: {
              error: false
            },
            field: { clearable: true},
            actionBar: {
              actions: ['clear'],
            }
          }}
          value={valueField}
        />
      </LocalizationProvider>
    </div>
  );
};

export default DatePicker;